
export default function LatestContent() {
  return (
    <section className="py-32 bg-[#0F2744]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-serif font-bold text-white mb-6">Our Role</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            기획부터 마케팅까지 전 과정을 하나의 전략으로 연결하는<br />
            <strong className="text-[#D4AF37]">1:1 밀착 리딩 시스템</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Step 1 */}
          <div className="relative group">
            <div className="bg-gradient-to-br from-[#1A2F4A] to-[#0A1628] rounded-2xl p-8 h-full hover:shadow-xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37]">
              <div className="flex items-center justify-between mb-6">
                <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center">
                  <span className="text-[#0A1628] text-xl font-bold">01</span>
                </div>
                <i className="ri-search-eye-line text-4xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">아이템 발굴 및<br />저자 분석</h3>
              <p className="text-gray-300 leading-relaxed">
                저자만의 고유한 강점을 정밀하게 분석합니다.
              </p>
            </div>
            {/* Arrow */}
            <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-3xl text-[#D4AF37]/30"></i>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative group">
            <div className="bg-gradient-to-br from-[#1A2F4A] to-[#0A1628] rounded-2xl p-8 h-full hover:shadow-xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37]">
              <div className="flex items-center justify-between mb-6">
                <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center">
                  <span className="text-[#0A1628] text-xl font-bold">02</span>
                </div>
                <i className="ri-lightbulb-flash-line text-4xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">컨셉 기획</h3>
              <p className="text-gray-300 leading-relaxed">
                독자의 삶을 바꾸는 '계기'가 될 수 있는 매력적인 컨셉을 도출합니다.
              </p>
            </div>
            {/* Arrow */}
            <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-3xl text-[#D4AF37]/30"></i>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative group">
            <div className="bg-gradient-to-br from-[#1A2F4A] to-[#0A1628] rounded-2xl p-8 h-full hover:shadow-xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37]">
              <div className="flex items-center justify-between mb-6">
                <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center">
                  <span className="text-[#0A1628] text-xl font-bold">03</span>
                </div>
                <i className="ri-edit-box-line text-4xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">편집 및<br />디자인 디렉팅</h3>
              <p className="text-gray-300 leading-relaxed">
                7년의 경험이 녹아든 완성도 높은 제작을 진행합니다.
              </p>
            </div>
            {/* Arrow */}
            <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-3xl text-[#D4AF37]/30"></i>
            </div>
          </div>

          {/* Step 4 */}
          <div className="group">
            <div className="bg-gradient-to-br from-[#1A2F4A] to-[#0A1628] rounded-2xl p-8 h-full hover:shadow-xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37]">
              <div className="flex items-center justify-between mb-6">
                <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center">
                  <span className="text-[#0A1628] text-xl font-bold">04</span>
                </div>
                <i className="ri-line-chart-line text-4xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">마케팅 전략</h3>
              <p className="text-gray-300 leading-relaxed">
                판매 데이터를 기반으로 한 정교한 셀링포인트 도출 및 광고를 집행합니다.
              </p>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-[#D4AF37]/10 px-8 py-4 rounded-full border border-[#D4AF37]/30">
            <i className="ri-shield-check-line text-2xl text-[#D4AF37]"></i>
            <p className="text-gray-200 font-medium">
              토탈 다이렉팅 시스템으로 책의 기획부터 출간, 마케팅까지 완벽하게 책임집니다
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
